import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { ChevronRight } from "lucide-react";
import * as React from "react";
import { cn } from "../lib/utils";

interface CollapsibleProps {
  trigger: React.ReactNode;
  defaultOpen?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  children: React.ReactNode;
  className?: string;
  triggerClassName?: string;
}

function Collapsible({
  trigger,
  defaultOpen,
  open,
  onOpenChange,
  children,
  className,
  triggerClassName,
}: CollapsibleProps) {
  return (
    <CollapsiblePrimitive.Root
      defaultOpen={defaultOpen}
      open={open}
      onOpenChange={onOpenChange}
      className={className}
    >
      <CollapsiblePrimitive.Trigger
        className={cn(
          "flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground [&[data-state=open]>svg]:rotate-90",
          triggerClassName,
        )}
      >
        <ChevronRight className="h-3.5 w-3.5 shrink-0 transition-transform duration-200" />
        {trigger}
      </CollapsiblePrimitive.Trigger>
      <CollapsiblePrimitive.Content className="overflow-hidden data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down">
        <div className="mt-2">{children}</div>
      </CollapsiblePrimitive.Content>
    </CollapsiblePrimitive.Root>
  );
}

export { Collapsible };
export type { CollapsibleProps };
